import { SsrService } from '@/common/services/ssr/ssr.service';
import { environment as env } from '@/env/environment';
import { AfterViewInit, Component } from '@angular/core';

declare const hbspt: any;

@Component({
    selector: 'fe-hbsptform-en-new',
    templateUrl: './hbsptformEn-new.component.html',
    styleUrls: ['./hbsptformEn-new.component.scss'],
})
export class HbsptformNewEnComponent implements AfterViewInit {
    constructor(private readonly ssr: SsrService) {}
    ngAfterViewInit(): void {
        if (this.ssr.isPlatformServer()) {
            return;
        }
        hbspt.forms.create({
            region: env.hbsptformennew.region,
            portalId: env.hbsptformennew.portalId,
            formId: env.hbsptformennew.formId,
            target: '#hubspotFormEnNew',
        });
    }
}
